'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var React = require('react');
require('../node_modules/prop-types/index.js');
var Tooltip = require('@material-ui/core/Tooltip');
var IconButton = require('@material-ui/core/IconButton');
var AutoSizeIcon = require('@material-ui/icons/ExpandRounded');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);
  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function () {
            return e[k];
          }
        });
      }
    });
  }
  n['default'] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
var Tooltip__default = /*#__PURE__*/_interopDefaultLegacy(Tooltip);
var IconButton__default = /*#__PURE__*/_interopDefaultLegacy(IconButton);
var AutoSizeIcon__default = /*#__PURE__*/_interopDefaultLegacy(AutoSizeIcon);

var AutoSizeButton = /*#__PURE__*/React__namespace.memo(_ref => {
  var {
    autoSizeColumns
  } = _ref;
  return /*#__PURE__*/React__namespace.createElement("div", null, /*#__PURE__*/React__namespace.createElement(Tooltip__default['default'], {
    title: "Auto-size columns"
  }, /*#__PURE__*/React__namespace.createElement(IconButton__default['default'], {
    onClick: autoSizeColumns
  }, /*#__PURE__*/React__namespace.createElement(AutoSizeIcon__default['default'], {
    className: "GenjoDataTable__auto-size-icon"
  }))));
});
AutoSizeButton.displayName = 'AutoSizeButton';
AutoSizeButton.propTypes = {};

exports.AutoSizeButton = AutoSizeButton;
